export const OCTOPUS_PARAPLANNER_SURFACE_ID = "octopus_paraplanner";
export const OPENWORK_ADVISOR_SURFACE_ID = "openwork_advisor";
export const SALTUS_ADVISOR_SURFACE_ID = "saltus_advisor";
export const SALTUS_ABACUS_ADVISER_SURFACE_ID = "saltus_abacus_adviser";
export const PROGENY_ADVISOR_SURFACE_ID = "progeny_advisor";
export const SALTUS_IM_SURFACE_ID = "saltus_im";
export type HomeSurfaceUserContext = {
  role?: string | null;
  modules?: string[] | null;
};

/** No client-side home surface guess — API ``is_primary`` is the source of truth. */
export function resolveParaplannerHomeSurfaceId(
  _companyId: string | null | undefined,
  _user?: HomeSurfaceUserContext | null,
): string | null {
  return null;
}

export function isOctopusParaplannerSurface(surfaceId: string): boolean {
  return surfaceId === OCTOPUS_PARAPLANNER_SURFACE_ID;
}

export function isOpenworkAdvisorSurface(surfaceId: string): boolean {
  return surfaceId === OPENWORK_ADVISOR_SURFACE_ID;
}

export function isSaltusAdvisorSurface(surfaceId: string): boolean {
  return surfaceId === SALTUS_ADVISOR_SURFACE_ID;
}

export function isSaltusAbacusAdviserSurface(surfaceId: string): boolean {
  return surfaceId === SALTUS_ABACUS_ADVISER_SURFACE_ID;
}

export function isProgenyAdvisorSurface(surfaceId: string): boolean {
  return surfaceId === PROGENY_ADVISOR_SURFACE_ID;
}

/** Adviser pilot homes hide the yellow admin “view as” strip (see surface `hide_admin_toolbar`). */
export function isAdviserPilotHomeSurface(surfaceId: string): boolean {
  return (
    isSaltusAdvisorSurface(surfaceId) ||
    isSaltusAbacusAdviserSurface(surfaceId) ||
    isProgenyAdvisorSurface(surfaceId)
  );
}

export function isSaltusImSurface(surfaceId: string): boolean {
  return surfaceId === SALTUS_IM_SURFACE_ID;
}
